import { FieldError } from "react-hook-form";

function isFieldError(
  obj: unknown | FieldError | undefined
): obj is FieldError {
  return (
    !!obj &&
    typeof obj === "object" &&
    Object.hasOwn(obj, "type") &&
    Object.hasOwn(obj, "message")
  );
}

/**
 * Helper function to extract all error messages from a deeply nested
 * react-hook-form error object.
 *
 * To get sensible output you need to pass an error message
 * and not just a boolean to the required react-hook-form config on your component.
 *
 * @param obj
 * @returns
 */
export const getFieldErrors = (obj: unknown): string[] => {
  if (!obj) {
    return [];
  }

  if (isFieldError(obj)) {
    return !!obj.message ? [obj.message] : [obj.type];
  }

  if (Array.isArray(obj)) {
    return obj.flatMap(getFieldErrors);
  }

  return Object.values(obj as Record<string, unknown>).flatMap(getFieldErrors);
};

export const numberValidator = (propertyName: string) => {
  return (value: unknown) =>
    Number.isNaN(value) || value === null || value === undefined
      ? `${propertyName} must be a number`
      : true;
};
